import styles from './FJFake3dCreation.module.less';
import PropTypes from 'prop-types';
import FJUtil from '../../../util/FJUtil';
import { useEffect, useRef } from 'react';
import WatermarkFullIcon from '../../../assets/svg/watermark-full.svg?react';
import { bindCanvas, init, updateViewSize } from '../../../store/FJFake3dStore';

const PADDING = 22;
const FJFake3dCreation = props => {
    const { deepMapImage, active } = props;
    const canvasRef = useRef(null);
    const canvasBoxRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current) {
            init();
            bindCanvas(canvasRef.current);
        }
    }, []);
    const _updateUI = FJUtil.throttle(() => {
        if (containerRef.current) {
            const { width, height } = containerRef.current.getBoundingClientRect();
            if (width > 0 && height > 0) {
                const canvasViewSize = FJUtil.fitSize(deepMapImage, {
                    width: width - PADDING * 2,
                    height: height - PADDING * 2,
                });
                // setCanvasStyle(canvasViewSize);
                canvasBoxRef.current.style.width = canvasViewSize.width + 'px';
                canvasBoxRef.current.style.height = canvasViewSize.height + 'px';
                updateViewSize(canvasViewSize.width, canvasViewSize.height);
            }
        }
    }, 50);
    useEffect(() => {
        setTimeout(() => {
            _updateUI();
        }, 500);
        window.addEventListener('resize', _updateUI);
        return () => {
            window.removeEventListener('resize', _updateUI);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deepMapImage]);

    return (
        <div className={styles.container} ref={containerRef} style={{ display: active ? 'flex' : 'none' }}>
            <div className={styles.canvas_box} ref={canvasBoxRef}>
                <canvas className={styles.canvas} ref={canvasRef}></canvas>
                {/* {deepMapImage && <img className={styles.deep_map_img} src={deepMapImage.src} />} */}

                <WatermarkFullIcon className={styles.watermark_img} />
            </div>
        </div>
    );
};
FJFake3dCreation.propTypes = {
    deepMapImage: PropTypes.object,
    originImage: PropTypes.object,
    active: PropTypes.bool,
};
export default FJFake3dCreation;
